<template>
  <div class="referrals-earnings">
    <h1>Referral Earnings</h1>
    <p>Track your referral earnings here</p>
  </div>
</template>

<script>
export default {
  name: "ReferralsEarnings"
}
</script>

<style scoped>
.referrals-earnings {
  padding: 20px;
}
</style>
